document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-pack-builder]");
  if (!root) return;

  const collection = root.dataset.mealsCollection || "meals";
  const packVariants = {
    6: root.dataset.pack6,
    9: root.dataset.pack9,
    12: root.dataset.pack12
  };

  let sellingPlans = [];
  try { sellingPlans = JSON.parse(root.dataset.sellingPlans || "[]"); } catch(e){ sellingPlans = []; }

  let required = 6;
  let selected = new Map(); // id -> product object
  let meals = [];
  let filtered = [];

  const grid = root.querySelector("[data-meal-grid]");
  const selectedEl = root.querySelector("[data-selected]");
  const requiredEl = root.querySelector("[data-required]");
  const caloriesEl = root.querySelector("[data-calories]");
  const addBtn = root.querySelector(".pb-add");
  const clearBtn = root.querySelector(".pb-clear");
  const msg = root.querySelector(".pb-message");
  const planSelect = root.querySelector(".pb-selling-plan");
  const searchInput = root.querySelector(".pb-search");
  const progressBar = root.querySelector("[data-progress-bar]");

  requiredEl.textContent = required;

  // Populate selling plans
  if (planSelect) {
    sellingPlans.forEach(p => {
      const opt = document.createElement("option");
      opt.value = String(p.id);
      opt.textContent = p.label;
      planSelect.appendChild(opt);
    });
  }

  // Pack size buttons
  root.querySelectorAll(".pb-pack-size button").forEach(btn => {
    btn.addEventListener("click", () => {
      root.querySelectorAll(".pb-pack-size button").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      required = parseInt(btn.dataset.size, 10);
      requiredEl.textContent = required;

      selected.clear();
      applyFilter();
      updateSummary();
      render();
      toast(`Pack size set to ${required}. Pick exactly ${required} meals.`, false);
    });
  });

  // Purchase type radio
  root.querySelectorAll("input[name='purchase_type']").forEach(r => {
    r.addEventListener("change", () => {
      const subscribing = r.value === "subscribe" && r.checked;
      if (planSelect) planSelect.disabled = !subscribing;
      if (subscribing) toast("Choose a subscription plan, then add your pack.", false);
      else toast("", false);
    });
  });

  // Search
  if (searchInput) {
    searchInput.addEventListener("input", () => {
      applyFilter();
      render();
    });
  }

  // Clear
  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      selected.clear();
      updateSummary();
      render();
      toast("Selection cleared.", false);
    });
  }

  // Fetch meals
  fetch(`/collections/${encodeURIComponent(collection)}/products.json?limit=250`)
    .then(r => r.json())
    .then(data => {
      meals = (data.products || []).map(p => normalizeProduct(p));
      filtered = meals;
      render();
      updateSummary();
      toast(`Loaded ${meals.length} meals.`, false);
    })
    .catch(() => {
      grid.innerHTML = `<div style="color:rgba(255,255,255,.7);padding:16px;">Could not load meals. Check collection handle: <strong>${collection}</strong></div>`;
    });

  // Delegate card clicks
  grid.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-toggle]");
    if (!btn) return;

    const id = Number(btn.getAttribute("data-toggle"));
    const meal = meals.find(m => m.id === id);
    if (!meal) return;

    if (selected.has(id)) {
      selected.delete(id);
    } else {
      if (selected.size >= required) {
        toast("Pack is full. Remove a meal before adding another.", true);
        return;
      }
      selected.set(id, meal);
    }

    updateSummary();
    render();
  });

  // Add to cart
  if (addBtn) {
    addBtn.addEventListener("click", () => {
      msg.textContent = "";

      const variant = packVariants[required];
      if (!variant) {
        toast("Pack variant ID is missing in theme settings. Add it in the Pack Builder section settings.", true);
        return;
      }

      if (selected.size !== required) {
        toast(`Select exactly ${required} meals to continue.`, true);
        return;
      }

      const subscribing = !planSelect?.disabled;
      const planId = planSelect?.value;

      if (subscribing && !planId) {
        toast("Select a subscription plan to continue.", true);
        return;
      }

      const mealTitles = Array.from(selected.values()).map(m => m.title).join(" | ");
      const calories = Array.from(selected.values()).reduce((s,m)=> s + (m.calories || 0), 0);

      const payloadItem = {
        id: Number(variant),
        quantity: 1,
        properties: {
          "_bundle_type": "pack_builder",
          "_pack_size": String(required),
          "_meals": mealTitles,
          "_calories_total": String(calories)
        }
      };

      // selling_plan only when subscribing
      if (subscribing) payloadItem.selling_plan = Number(planId);

      addBtn.disabled = true;
      fetch("/cart/add.js", {
        method:"POST",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify({ items: [payloadItem] })
      })
      .then(r => {
        if (!r.ok) return r.text().then(t => { throw new Error(t || "Add to cart failed"); });
        window.location.href = "/cart";
      })
      .catch(err => {
        addBtn.disabled = false;
        toast(`Error adding to cart. ${err.message}`, true);
      });
    });
  }

  function normalizeProduct(p){
    // Optional macro tags format: CAL:450 etc.
    const macros = parseMacroTags(p.tags || []);
    const img = (p.images && p.images.length) ? p.images[0].src : "";
    return {
      id: Number(p.id),
      title: p.title,
      image: img,
      calories: macros.cal || 0,
      protein: macros.pro || 0,
      carbs: macros.carb || 0,
      fat: macros.fat || 0
    };
  }

  function parseMacroTags(tags){
    const out = { cal:0, pro:0, carb:0, fat:0 };
    for (const t of tags){
      let m;
      m = String(t).match(/^CAL:(\d+)$/i); if (m) out.cal = parseInt(m[1],10);
      m = String(t).match(/^PRO:(\d+)$/i); if (m) out.pro = parseInt(m[1],10);
      m = String(t).match(/^CARB:(\d+)$/i); if (m) out.carb = parseInt(m[1],10);
      m = String(t).match(/^FAT:(\d+)$/i); if (m) out.fat = parseInt(m[1],10);
    }
    return out;
  }

  function applyFilter(){
    const q = (searchInput?.value || "").trim().toLowerCase();
    filtered = meals.filter(m => !q || m.title.toLowerCase().includes(q));
  }

  function updateSummary(){
    selectedEl.textContent = String(selected.size);
    requiredEl.textContent = String(required);

    const calories = Array.from(selected.values()).reduce((s,m)=> s + (m.calories || 0), 0);
    caloriesEl.textContent = String(calories);

    const pct = required ? Math.min(100, Math.round((selected.size / required) * 100)) : 0;
    if (progressBar) progressBar.style.width = `${pct}%`;

    if (addBtn) addBtn.disabled = selected.size !== required;
  }

  function render(){
    const list = filtered.length ? filtered : meals;

    if (!list.length){
      grid.innerHTML = `<div style="color:rgba(255,255,255,.7);padding:16px;">No meals found.</div>`;
      return;
    }

    grid.innerHTML = list.map((m) => {
      const isSelected = selected.has(m.id);
      const badge = m.calories ? `${m.calories} cal` : "Meal";
      return `
        <article class="pb-card ${isSelected ? "selected" : ""}">
          ${m.image ? `<img class="pb-card__img" src="${m.image}" alt="${escapeHtml(m.title)}">` : `<div class="pb-card__img"></div>`}
          <div class="pb-card__body">
            <div class="pb-card__top">
              <h3 class="pb-card__title">${escapeHtml(m.title)}</h3>
              <span class="pb-badge">${badge}</span>
            </div>

            <div class="pb-macros">
              <span>CAL ${m.calories || 0}</span>
              <span>P ${m.protein || 0}g</span>
              <span>C ${m.carbs || 0}g</span>
              <span>F ${m.fat || 0}g</span>
            </div>

            <button type="button" class="pb-card__btn" data-toggle="${m.id}">
              ${isSelected ? "Selected ✓" : "Add meal"}
            </button>
          </div>
        </article>
      `;
    }).join("");
  }

  function toast(text, isError){
    if (!msg) return;
    msg.textContent = text || "";
    msg.style.color = isError ? "var(--pb-danger)" : "rgba(255,255,255,.75)";
  }

  function escapeHtml(str){
    return String(str || "")
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }
});
